var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M10 13.75c2.746 0 5.148 1.181 6.455 2.944l-1.382.653C14.01 16.087 12.135 15.25 10 15.25s-4.01.837-5.073 2.097l-1.381-.654C4.85 14.93 7.253 13.75 9.999 13.75M10 2.5a3.75 3.75 0 0 1 3.75 3.75V8.5a3.75 3.75 0 0 1-3.588 3.746L10 12.25A3.75 3.75 0 0 1 6.25 8.5V6.25a3.75 3.75 0 0 1 3.588-3.746zM10 4a2.25 2.25 0 0 0-2.247 2.118l-.004.132V8.5a2.25 2.25 0 0 0 4.497.132l.003-.132V6.25A2.25 2.25 0 0 0 10 4"
  })));
};
export default SvgUser;